<!-- 彈窗 編輯附加品項群組-->
<ng-template #Modal let-data let-ref="dialogRef">
 
<!-- #ModalF="ngForm" nb-select multiple 在Form中 無法使用ngModel 所所以先拿掉Form-->
  <div > 
    <nb-card class="staffInfoTemplate" style="width: 1400px;"  [nbSpinner]="info.IsLoding">
      <!-- 標題 -->
      <nb-card-header *ngIf="info.moType==1">新增附加品項群組
      </nb-card-header>
      <nb-card-header *ngIf="info.moType==2">編輯附加品項群組
      </nb-card-header>
      <nb-card-header *ngIf="info.moType==3">複製附加品項群組
      </nb-card-header>
      <nb-card-header *ngIf="info.moType==4">查看附加品項群組
      </nb-card-header>

      <!-- 內容 -->
      <nb-card-body>
        <div class="row rowTop">
          <div class="row mx-0 col-lg-6" *ngIf="GroupList && !info.orgType " >
            <label class="label col-sm-12 col-form-label ">所屬分類</label>
            <!-- TODO: nb-select multiple 在Form中 無法使用ngModel -->
            <nb-select multiple  placeholder="選擇分類"     name="ModelNoListF"    
                [disabled]="info.moType==4"         
                [(ngModel)]="attGroup.ModelNoList">
              <nb-option *ngFor="let item of GroupList" [value]="item.value"> {{ item.content }}</nb-option>            
            </nb-select>
          </div>

          <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label required">附加品項群組標題</label>
            <input name="GroupName" nbInput required [disabled]="info.moType==4" 
              autocomplete="off" 
              [(ngModel)]="attGroup.GroupName">
          </div>

          <!-- <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label ">排序</label>
            <input name="Sorting" nbInput required [disabled]="info.moType==4" 
              autocomplete="off" 
              [(ngModel)]="attGroup.Sorting">
          </div> -->


        </div>





        <div class="row rowTop">
          <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label">群組選項類型</label>
            <nb-select [disabled]="info.moType==4" [(ngModel)]="attGroup.AttachItemKind" name="AttachItemKind">
              <nb-option value="1">單選</nb-option>
              <nb-option value="2">複選</nb-option>
            </nb-select>
          </div>

          <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label">是否必選</label>
            <nb-select [disabled]="info.moType==4" [(ngModel)]="attGroup.IsRequired" name="IsRequired">
              <nb-option value="1">必選</nb-option>
              <nb-option value="0">非必選</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row rowTop" *ngIf="attGroup.AttachItemKind ==2">
          <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label">是否規則一致</label>
            <nb-select [disabled]="info.moType==4" [(ngModel)]="attGroup.IsConsistent" name="IsReqIsConsistentuired">
              <nb-option value="1">是</nb-option>
              <nb-option value="0">否</nb-option>
            </nb-select>
          </div>
        </div>


        <div class="row rowTop"  *ngIf="attGroup.AttachItemKind ==2">
          <div class="row mx-0 col-lg-6">
            <label class="label col-sm-12 col-form-label">群組內選項總計 最多可選量</label>
            <input type="number" name="SelectUpLimit" nbInput min="0" [disabled]="info.moType==4" [(ngModel)]="attGroup.SelectUpLimit">
          </div>

          <div class="row mx-0 col-lg-6" >
            <label class="label col-sm-12 col-form-label">群組內選項總計 最少需選量(線上點餐)</label>
            <input type="number" name="SelectUpLimit" nbInput min="0" [disabled]="info.moType==4" [(ngModel)]="attGroup.SelectMinLimit">
          </div>
        </div>

        <div class="row rowTop">
          <div class=" mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">出單不顯示數量</label>
            <nb-toggle
              name="IsNoDisplayQuantity "
              [disabled]="info.moType==4"
              [(checked)]="attGroup.IsNoDisplayQuantity"
            ></nb-toggle>
          </div>
        </div>

        <div class="row rowTop">
          <div class=" mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">計入小計數量</label>
            <nb-toggle
              name="IsSumSubtotalQty "
              [disabled]="info.moType==4"
              [(checked)]="attGroup.IsSumSubtotalQty"
            ></nb-toggle>
          </div>
        </div>

        <div class="row col-sm-12 mt-3"  *ngIf="info.moType!=4">

          <button nbButton (click)="EditAttachMO.onOpen(1,null)" class="mr-3">新增選項</button>
          <button nbButton (click)="AttachListMO.onOpen()"  class="mr-3">加入現有選項</button>
          <button nbButton (click)="ProductListMO.onOpen()">加入商品做選項</button>
        </div>

        <div class="row col-sm-12  mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th style="width: 60px;min-width:initial;">排序</th>
                <th>選項名稱</th>
                <!-- <th>稅別</th> -->
                <!-- <th>稅率</th> -->
                <th>數量</th>
                <th>原價</th>
                <th>售價</th>
                <th *ngIf="attGroup.AttachItemKind==2">POS、線上點餐<br/>最多可選量</th>
                <th *ngIf="attGroup.AttachItemKind==2">線上點餐<br/>最少可選量</th>
                <th>POS、<br/>線上點餐預設</th>
                <th>類型</th>
                <td *ngIf="info.orgType==3">
                  停售
                </td> 
                <th>出單不顯示數量</th>
                <th>計入小計數量</th>
                <th style="min-width: 200px;">管理</th>
              </tr>
            </thead>
            <tbody class="td-w80">
              <tr *ngFor="let att of attGroup.PRDAttachItemList; let i = index; trackBy: trackItem">
                <td>
                  <input nbInput type="number" *ngIf="info.moType!=4"
                  [name]="'AttSelectSorting_'+index" min="0" 
                  [(ngModel)]="att.Sorting" style="width: 80px">
                  <span *ngIf="info.moType==4">{{att.Sorting}}</span>   
                </td>
                 
                <td>
                  
                  <!-- {{att.AttachItemName && att.AttachItemName!="" ? att.AttachItemName : att.ProductName}} -->

                 {{att.ItemName}}
                <br/>
                  
                </td>
                <!-- <td>
                  <nb-select name="TaxType_{{i}}" status="warning" *ngIf="!att.PRDAttachItemNo"
                    [(selected)]="att.TaxType">
                    <nb-option *ngFor="let tax of TaxTypeList" [value]="tax.value">{{tax.content}}</nb-option>
                  </nb-select>

                  <label *ngIf="att.PRDAttachItemNo">
                    {{att.TaxType | tranf : TaxTypeList : 'key' : 'value'}}
                  </label>
                </td> -->
                <!-- <td>
                  <nb-select name="TaxType_{{i}}" status="warning" 
                    *ngIf="!att.PRDAttachItemNo" [(selected)]="att.TaxRate">
                    <nb-option *ngFor="let x of TaxRateList;" [value]="x">{{x}} %</nb-option>
                  </nb-select>

                  <label *ngIf="att.PRDAttachItemNo">
                    {{att.TaxRate}} %
                  </label>
                </td> -->

                <td>
                  {{att.Quantity}}
                </td>

                <td>
                  {{att.Cash}}
                </td>

                <td>
                  <span *ngIf="info.moType==4">{{att.SaleCash}}</span>
                  <input  *ngIf="info.moType!=4" style="width: 100px" nbInput name="SaleCash_{{i}}" [(ngModel)]="att.SaleCash" type="number" min="0">
                </td>
                <td *ngIf="attGroup.AttachItemKind==2">
                  <span *ngIf="info.moType==4">{{att.MaxSelectTimes}}</span>
                  <input  *ngIf="info.moType!=4" style="width: 100px" nbInput name="MaxSelectTimes_{{i}}" [(ngModel)]="att.MaxSelectTimes" type="number" min="0">
                </td>
                <td *ngIf="attGroup.AttachItemKind==2">
                  <span *ngIf="info.moType==4">{{att.MinSelectTimes}}</span>
                  <input  *ngIf="info.moType!=4" style="width: 100px" nbInput name="MinSelectTimes_{{i}}" [(ngModel)]="att.MinSelectTimes" type="number" [min]="attGroup.IsRequired ? 1 : 0">
                </td>
                <td >
                  <button *ngIf="att.IsDefault" (click)="info.moType==4 ? null : selectDefault(att,'IsDefault')"
                    class="btn btn-info py-0 px-1 radiobtn"> <i class="fa fa-check"></i>       </button>          
                 
                  <button *ngIf="!att.IsDefault" (click)="info.moType==4 ? null : selectDefault(att,'IsDefault')"
                    class="btn btn-info py-0 px-1  radiobtn " >    </button>   
                       
                </td> 
                <td>
                  {{ att.PRDProductNo  ? '商品' : '選項'}}
                </td>  
                <td *ngIf="info.orgType==3">
                  {{ att.IsSell  ? '否' : '是'}}
                </td>  

                <td>
                  <button 
                    [disabled]="info.moType === 4"
                    (click)="att.IsNoDisplayQuantity = !att.IsNoDisplayQuantity"
                    class="btn btn-info py-0 px-1 radiobtn"
                  >
                    <i *ngIf="att.IsNoDisplayQuantity" class="fa fa-check"></i>
                  </button>
                </td>  

                <td>
                  <button 
                    [disabled]="info.moType === 4"
                    (click)="att.IsSumSubtotalQty = !att.IsSumSubtotalQty"
                    class="btn btn-info py-0 px-1 radiobtn"
                  >
                    <i *ngIf="att.IsSumSubtotalQty" class="fa fa-check"></i>
                  </button>
                </td> 

                <td>
                  <!-- att.PRDProductNo -->
                  <!-- att.PRDAttachItemNo -->
                  
                  <a (click)="ProductEditMo.onOpen(4,att.PRDProductNo)" *ngIf="att.PRDProductNo ">
                    <i class="fas fa-search">查看</i>
                  </a>
                  <a (click)="EditAttachMO.onOpen(4,att)"  
                    *ngIf="!att.PRDProductNo && 
                    (info.moType==4  || (info.ORG_Store_ID && info.ORG_Store_ID != att.CreateStore) )">
                    <i class="fas fa-search">查看</i>
                  </a>    

                  <!-- 商品停/啟用
                  <a (click)="EditAttachMO.onDelete(att, true)"  
                    *ngIf="!att.PRDProductNo && 
                    (info.moType==4  || (info.ORG_Store_ID && info.ORG_Store_ID != att.CreateStore))
                    && att.IsSell">
                    <i class="fas fa-search">停用</i>
                  </a>  
                  <a (click)="EditAttachMO.onDelete(att, false)"  
                    *ngIf="!att.PRDProductNo && 
                    (info.moType==4  || (info.ORG_Store_ID && info.ORG_Store_ID != att.CreateStore))
                    && !att.IsSell">
                    <i class="fas fa-search">啟用</i>
                  </a>   -->
                  <a (click)="EditAttachMO.onOpen(2,att)"  
                    *ngIf="!att.PRDProductNo && info.moType!=4 && !(info.ORG_Store_ID && info.ORG_Store_ID != att.CreateStore)">
                    <i class="fas fa-edit">編輯 </i>
                  </a>    
                  <a (click)="EditAttAKAMo.onOpen(2, att)"  
                    *ngIf="!att.PRDProductNo && info.moType!=4">
                    <i class="fas fa-edit">編輯別名 </i>
                  </a>
                  <a (click)="EditLanguageMo.onOpen(att)"  
                    *ngIf="!att.PRDProductNo && info.moType!=4">
                    <i class="fas fa-edit">編輯多語言 </i>
                  </a>
                  <a (click)="onDel(i)" *ngIf="info.moType!=4" >                   
                    <i class="fas fa-times-circle">刪除</i>
                  </a>
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </nb-card-body>

      <!-- 腳 -->
      <nb-card-footer>
        <button  *ngIf="info.moType!=4" nbButton (click)="onSave();" 
          [disabled]="!attGroup.GroupName || attGroup.GroupName=='' ||
                      !attGroup.PRDAttachItemList ||
                      attGroup.PRDAttachItemList.length == 0">儲存</button>
        <button nbButton (click)="ref.close()">關閉</button>

  
      </nb-card-footer>

    </nb-card>
  </div>  
</ng-template>
  


<!-- 編輯別名 -->
<ng-template #EditAttAKAMoDOM let-data let-ref="dialogRef">
  <form #EditAttAKAMoF="ngForm">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      編輯-{{EditAttAKAMo.info.ProductName}}-商品別名
    </nb-card-header>

    <nb-card-body>
      <!-- 總部時專用 -->
      <div class="row mb-2" *ngIf="false">
        <b class=" col-auto col-form-label " style="width: 120px;">選擇門市</b>
        <div class="col">
          <nb-select fullWidth name="selectStore" [(ngModel)]="EditAttAKAMo.data.selectStore">
            <nb-option *ngFor="let e of storeSelectList" [value]="e.value" (selectedChange)="EditAttAKAMo.getData()">
              {{ e.content }}
            </nb-option>
          </nb-select>
        </div>
      </div>

      
      <div class="row mb-2" *ngFor="let item of EditAttAKAMo.data.List;let i = index ">
        <b class="text-gray col-auto col-form-label " style="width: 120px;">{{item.TypeName}}</b>
        <div class="col">
          <input [name]="'Name'+i"  nbInput fullWidth 
          [(ngModel)]="item.Name"
          [disabled]="EditAttAKAMo.info.moType==4">
        </div>
      </div>
    
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="EditAttAKAMo.onSave();" >儲存</button>
      <button nbButton (click)="ref.close()">關閉</button>
    </nb-card-footer>

  </nb-card>
</form>
</ng-template>

<!-- 編輯多語言 -->
<ng-template #EditLanguageMoDOM let-data let-ref="dialogRef">
  <form #EditLanguageMoF="ngForm">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      編輯-{{EditLanguageMo.info.ProductName}}-附加商品多語言
    </nb-card-header>

    <nb-card-body>
      <div class="row mb-2" *ngFor="let item of EditLanguageMo.data.List;let i = index ">
        <b class="text-gray col-auto col-form-label">{{item.LanguageName}}</b>
        <div class="row mx-0 col-lg-12">
          <!-- <label class="label col-sm-12 col-form-label">多語言附加商品名稱</label> -->
          <input [name]="'Name'+i"  nbInput fullWidth 
          [(ngModel)]="item.Name"
          [disabled]="EditLanguageMo.info.moType==4">
        </div>
      </div>
    
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="EditLanguageMo.onSave();" >儲存</button>
      <button nbButton (click)="ref.close()">關閉</button>
    </nb-card-footer>

  </nb-card>
</form>
</ng-template>

  
  <!-- 彈窗 選擇已存在的商品-->
  <app-select-product  #ProductListMO_Tmp
  *ngIf="ProductListMO.isShow"
  [info]="ProductListMO.info"
  [orgData]="ProductListMO.data"
  (emitList)="ProductListMO.onSave($event)" 
  (emitClose)="ProductListMO.onClose($event)" 
  >
 </app-select-product>

 

  <!-- 彈窗 查看商品-->
    <app-edit-product  #ProductEditMo_Tmp
      *ngIf="ProductEditMo.isShow"
      [info]="ProductEditMo.info"
      [orgData]="ProductEditMo.data"
      (emitClose)="ProductEditMo.onClose($event)" >
   </app-edit-product>
  

   <!-- 彈窗 編輯附加品項-->
   <app-edit-attach  #EditAttachMO_Tmp
   *ngIf="EditAttachMO.isShow"  
   [info]="EditAttachMO.info" 
   [orgData]="EditAttachMO.data"
   (emitList)="EditAttachMO.onSave($event)"
   (emitClose)="EditAttachMO.onClose($event)"  >
  </app-edit-attach>
  
  
   <!-- 彈窗 選擇已存在的附加品項-->
   <app-select-attach  #AttachListMO_Tmp
   *ngIf="AttachListMO.isShow"   
   [info]="AttachListMO.info"
   [orgData]="AttachListMO.data"
   (emitList)="AttachListMO.onSave($event)"
   (emitClose)="AttachListMO.onClose($event)"  [title]="'選擇附加品項選項'">
  </app-select-attach>
  